/**
 * @fileoverview MessageConst const<br>
 * 本ファイルは定義書より出力されるため直接編集禁止<br>
 * 変更がある場合は定義書を変更しファイルを生成してください。
 */
'use strict';
const MessageConst = {
  COMMON: {
    /**
     * LogiPull - ロジプル -
     * @name ID001
     * @constant
     * @memberOf const.MessageConst
     */
    ID001: 'LogiPull - ロジプル -',

    /**
     * マイページ
     * @name ID002
     * @constant
     * @memberOf const.MessageConst
     */
    ID002: 'マイページ',

    /**
     * ログアウト
     * @name ID003
     * @constant
     * @memberOf const.MessageConst
     */
    ID003: 'ログアウト',

    /**
     * ホーム
     * @name ID101
     * @constant
     * @memberOf const.MessageConst
     */
    ID101: 'ホーム',

    /**
     * 車両管理
     * @name ID102
     * @constant
     * @memberOf const.MessageConst
     */
    ID102: '車両管理',

    /**
     * ドライバー管理
     * @name ID103
     * @constant
     * @memberOf const.MessageConst
     */
    ID103: 'ドライバー管理',

    /**
     * © 2021 Computer Engineering & Consulting, Ltd.
     * @name ID201
     * @constant
     * @memberOf const.MessageConst
     */
    ID201: '© 2023 Computer Engineering & Consulting, Ltd.',

    /**
     * OK
     * @name ID301
     * @constant
     * @memberOf const.MessageConst
     */
    ID301: 'OK',

    /**
     * キャンセル
     * @name ID302
     * @constant
     * @memberOf const.MessageConst
     */
    ID302: 'キャンセル',

    /**
     * ja<br>
     * ローカライズ文字列
     * @name ID401
     * @constant
     * @memberOf const.MessageConst
     */
    ID401: 'ja',

    /**
     * yyyy/mm/dd HH:mm<br>
     * moment.js 年月日時分
     * @name ID402
     * @constant
     * @memberOf const.MessageConst
     */
    ID402: 'yyyy/mm/dd HH:mm',

    /**
     * YYYY/MM/DD<br>
     * moment.js 年月日
     * @name ID403
     * @constant
     * @memberOf const.MessageConst
     */
    ID403: 'YYYY/MM/DD',

    /**
     * mm月<br>
     * moment.js 月
     * @name ID404
     * @constant
     * @memberOf const.MessageConst
     */
    ID404: 'mm月',

    /**
     * yyyy<br>
     * moment.js 年
     * @name ID405
     * @constant
     * @memberOf const.MessageConst
     */
    ID405: 'yyyy',

    /**
     * HH:mm<br>
     * moment.js 時分
     * @name ID406
     * @constant
     * @memberOf const.MessageConst
     */
    ID406: 'HH:mm',

    /**
     * YYYY年MM月DD日(ddd)<br>
     * mobiscroll dataFormat
     * @name ID407
     * @constant
     * @memberOf const.MessageConst
     */
    ID407: 'YYYY年MM月DD日(ddd)',

    /**
     * ：
     * @name ID501
     * @constant
     * @memberOf const.MessageConst
     */
    ID501: '：',

    /**
     * -
     * @name ID502
     * @constant
     * @memberOf const.MessageConst
     */
    ID502: '-',

    /**
     * ～
     * @name ID503
     * @constant
     * @memberOf const.MessageConst
     */
    ID503: '～',

    /**
     * ×
     * @name ID504
     * @constant
     * @memberOf const.MessageConst
     */
    ID504: '×',

    /**
     * T
     * @name ID505
     * @constant
     * @memberOf const.MessageConst
     */
    ID505: 'T',

    /**
     * 分
     * @name ID506
     * @constant
     * @memberOf const.MessageConst
     */
    ID506: '分',

    /**
     * 休
     * @name ID507
     * @constant
     * @memberOf const.MessageConst
     */
    ID507: '休',

    /**
     * 必須
     * @name ID508
     * @constant
     * @memberOf const.MessageConst
     */
    ID508: '必須',

    /**
     * 月
     * @name ID509
     * @constant
     * @memberOf const.MessageConst
     */
    ID509: '月',

    /**
     * 火
     * @name ID510
     * @constant
     * @memberOf const.MessageConst
     */
    ID510: '火',

    /**
     * 水
     * @name ID511
     * @constant
     * @memberOf const.MessageConst
     */
    ID511: '水',

    /**
     * 木
     * @name ID512
     * @constant
     * @memberOf const.MessageConst
     */
    ID512: '木',

    /**
     * 金
     * @name ID513
     * @constant
     * @memberOf const.MessageConst
     */
    ID513: '金',

    /**
     * 土
     * @name ID514
     * @constant
     * @memberOf const.MessageConst
     */
    ID514: '土',

    /**
     * 日
     * @name ID515
     * @constant
     * @memberOf const.MessageConst
     */
    ID515: '日',

    /**
     * ・
     * @name ID516
     * @constant
     * @memberOf const.MessageConst
     */
    ID516: '・',

    /**
     * 検索結果件数
     * @name ID517
     * @constant
     * @memberOf const.MessageConst
     */
    ID517: '検索結果件数',

    /**
     * @
     * @name ID518
     * @constant
     * @memberOf const.MessageConst
     */
    ID518: '@',

    /**
     * ログイン画面に戻る
     * @name ID519
     * @constant
     * @memberOf const.MessageConst
     */
    ID519: 'ログイン画面に戻る',

    /**
     * ※
     * @name ID520
     * @constant
     * @memberOf const.MessageConst
     */
    ID520: '※',

    /**
     * 「-」は入力しないでください。
     * @name ID521
     * @constant
     * @memberOf const.MessageConst
     */
    ID521: '「-」は入力しないでください。',

    /**
     * 条件を指定して検索<br>
     * スマホ対応
     * @name ID522
     * @constant
     * @memberOf const.MessageConst
     */
    ID522: '条件を指定して検索',

    /**
     * 削除対象にする<br>
     * スマホ対応
     * @name ID523
     * @constant
     * @memberOf const.MessageConst
     */
    ID523: '削除対象にする',

    /**
     * ログインID
     * @name ID601
     * @constant
     * @memberOf const.MessageConst
     */
    ID601: 'ログインID',

    /**
     * パスワード
     * @name ID602
     * @constant
     * @memberOf const.MessageConst
     */
    ID602: 'パスワード',

    /**
     * xxxxx@xxx.co.jp
     * @name ID603
     * @constant
     * @memberOf const.MessageConst
     */
    ID603: 'xxxxx@xxx.co.jp',

    /**
     * 50文字まで
     * @name ID604
     * @constant
     * @memberOf const.MessageConst
     */
    ID604: '50文字まで',

    /**
     * 半角英数字8~32文字
     * @name ID605
     * @constant
     * @memberOf const.MessageConst
     */
    ID605: '半角英数字8~32文字',

    /**
     * 全角1~4桁
     * @name ID606
     * @constant
     * @memberOf const.MessageConst
     */
    ID606: '全角1~4桁',

    /**
     * 半角数字・半角英字(大文字のみ) 1～3桁
     * @name ID607
     * @constant
     * @memberOf const.MessageConst
     */
    ID607: '半角数字・半角英字(大文字のみ) 1～3桁',

    /**
     * ひらがな1文字
     * @name ID608
     * @constant
     * @memberOf const.MessageConst
     */
    ID608: 'ひらがな1文字',

    /**
     * 半角数字1~4桁
     * @name ID609
     * @constant
     * @memberOf const.MessageConst
     */
    ID609: '半角数字1~4桁',

    /**
     * 09012345678
     * @name ID610
     * @constant
     * @memberOf const.MessageConst
     */
    ID610: '09012345678',

    /**
     * 一連番号を入力
     * @name ID611
     * @constant
     * @memberOf const.MessageConst
     */
    ID611: '一連番号を入力',

    /**
     * 2<br>
     * 利用バース数
     * @name ID612
     * @constant
     * @memberOf const.MessageConst
     */
    ID612: '2',

    /**
     * 120<br>
     * 作業時間
     * @name ID613
     * @constant
     * @memberOf const.MessageConst
     */
    ID613: '120',

    /**
     * 半角英数字記号8~32文字
     * @name ID614
     * @constant
     * @memberOf const.MessageConst
     */
    ID614: '半角英数字記号8~32文字',

    /**
     * 通信が混雑しています。しばらくたってから、再度実行してください。
     * @name ID701
     * @constant
     * @memberOf const.MessageConst
     */
    ID701: '通信が混雑しています。しばらくたってから、再度実行してください。',

    /**
     * を入力してください。
     * @name ID702
     * @constant
     * @memberOf const.MessageConst
     */
    ID702: 'を入力してください。',

    /**
     * が不正です。
     * @name ID703
     * @constant
     * @memberOf const.MessageConst
     */
    ID703: 'が不正です。',

    /**
     * は半角英数字で入力してください。
     * @name ID704
     * @constant
     * @memberOf const.MessageConst
     */
    ID704: 'は半角英数字で入力してください。',

    /**
     * 該当ページが存在しません。先頭ページを表示します。
     * @name ID705
     * @constant
     * @memberOf const.MessageConst
     */
    ID705: '該当ページが存在しません。先頭ページを表示します。',

    /**
     * は50桁以内で入力してください。
     * @name ID706
     * @constant
     * @memberOf const.MessageConst
     */
    ID706: 'は50桁以内で入力してください。',

    /**
     * は半角数字・半角英字(大文字のみ) 1～3桁で入力してください。
     * @name ID707
     * @constant
     * @memberOf const.MessageConst
     */
    ID707: 'は半角数字・半角英字(大文字のみ) 1～3桁で入力してください。',

    /**
     * 行目
     * @name ID708
     * @constant
     * @memberOf const.MessageConst
     */
    ID708: '行目',

    /**
     * ファイルを選択してください。
     * @name ID709
     * @constant
     * @memberOf const.MessageConst
     */
    ID709: 'ファイルを選択してください。',

    /**
     * ファイルのアップロードに失敗しました。
     * @name ID710
     * @constant
     * @memberOf const.MessageConst
     */
    ID710: 'ファイルのアップロードに失敗しました。',

    /**
     * しばらくたってから、再度実行してください。
     * @name ID711
     * @constant
     * @memberOf const.MessageConst
     */
    ID711: 'しばらくたってから、再度実行してください。',

    /**
     * CSVファイルを選択してください。
     * @name ID712
     * @constant
     * @memberOf const.MessageConst
     */
    ID712: 'CSVファイルを選択してください。',

    /**
     * 指定いただいたログインIDはご使用になれません。
     * @name ID713
     * @constant
     * @memberOf const.MessageConst
     */
    ID713: '指定いただいたログインIDはご使用になれません。',

    /**
     * 現在のパスワードが間違っています。
     * @name ID714
     * @constant
     * @memberOf const.MessageConst
     */
    ID714: '現在のパスワードが間違っています。',

    /**
     * 新しいパスワード(確認用)の入力が、新しいパスワードの入力と異なります。
     * @name ID715
     * @constant
     * @memberOf const.MessageConst
     */
    ID715:
      '新しいパスワード(確認用)の入力が、新しいパスワードの入力と異なります。',

    /**
     * メールアドレス(確認用)の入力が、メールアドレスの入力と異なります。
     * @name ID716
     * @constant
     * @memberOf const.MessageConst
     */
    ID716: 'メールアドレス(確認用)の入力が、メールアドレスの入力と異なります。',

    /**
     * は8文字以上32文字以内で入力してください。
     * @name ID717
     * @constant
     * @memberOf const.MessageConst
     */
    ID717: 'は8文字以上32文字以内で入力してください。',

    /**
     * ログインに失敗しました。
     * @name ID718
     * @constant
     * @memberOf const.MessageConst
     */
    ID718: 'ログインに失敗しました。',

    /**
     * ログインIDまたはパスワードが間違っています。
     * @name ID719
     * @constant
     * @memberOf const.MessageConst
     */
    ID719: 'ログインIDまたはパスワードが間違っています。',

    /**
     * 旧パスワードが正しくありません。
     * @name ID720
     * @constant
     * @memberOf const.MessageConst
     */
    ID720: '旧パスワードが正しくありません。',

    /**
     * は4桁以内で入力してください。
     * @name ID721
     * @constant
     * @memberOf const.MessageConst
     */
    ID721: 'は4桁以内で入力してください。',

    /**
     * しますか？
     * @name ID722
     * @constant
     * @memberOf const.MessageConst
     */
    ID722: 'しますか？',

    /**
     * を正しく入力してください。
     * @name ID723
     * @constant
     * @memberOf const.MessageConst
     */
    ID723: 'を正しく入力してください。',

    /**
     * 削除するドライバーを選択してください。
     * @name ID724
     * @constant
     * @memberOf const.MessageConst
     */
    ID724: '削除するドライバーを選択してください。',

    /**
     * 削除したドライバーはシステムを利用できなくなります。
     * @name ID725
     * @constant
     * @memberOf const.MessageConst
     */
    ID725: '削除したドライバーはシステムを利用できなくなります。',

    /**
     * は半角英数記号で入力してください。
     * @name ID726
     * @constant
     * @memberOf const.MessageConst
     */
    ID726: 'は半角英数記号で入力してください。',

    /**
     * メールアドレス
     * @name ID727
     * @constant
     * @memberOf const.MessageConst
     */
    ID727: 'メールアドレス',

    /**
     * 電話番号は半角数字のみで入力してください。1文字目は「0」を入力してください。
     * @name ID728
     * @constant
     * @memberOf const.MessageConst
     */
    ID728:
      '電話番号は半角数字のみで入力してください。1文字目は「0」を入力してください。',

    /**
     * 入力された運送会社が存在しません。
     * @name ID729
     * @constant
     * @memberOf const.MessageConst
     */
    ID729: '入力された運送会社が存在しません。',

    /**
     * 入力されたログインIDはすでに使用されています。
     * @name ID730
     * @constant
     * @memberOf const.MessageConst
     */
    ID730: '入力されたログインIDはすでに使用されています。',

    /**
     * は半角数字のみで入力してください。
     * @name ID731
     * @constant
     * @memberOf const.MessageConst
     */
    ID731: 'は半角数字のみで入力してください。'
  },

  LOGIN: {
    /**
     * ログイン
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'ログイン',

    /**
     * ※ パスワードを忘れた方は
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '※ パスワードを忘れた方は',

    /**
     * ※ 新規登録する方は
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '※ 新規登録する方は',

    /**
     * こちら
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: 'こちら',

    /**
     * から
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: 'から'
  },
  ACCOUNT_COMMON: {
    /**
     * （確認用）
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '（確認用）',

    /**
     * キャンセル
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'キャンセル',

    /**
     * 送信
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '送信',

    /**
     * 入力されたメールアドレスに送信しました。
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '入力されたメールアドレスに送信しました。',

    /**
     * 既に本登録されています。
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '既に本登録されています。',

    /**
     * 有効期限が切れています。再度仮登録から行ってください。
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '有効期限が切れています。再度仮登録から行ってください。',

    /**
     * パスワード(確認用)の入力が、パスワードの入力と異なります。
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: 'パスワード(確認用)の入力が、パスワードの入力と異なります。',

    /**
     * ユーザー登録されました。
     * @name ID035
     * @constant
     * @memberOf const.MessageConst
     */
    ID035: 'ユーザー登録されました。',

    /**
     * ログイン画面にお戻りください。
     * @name ID036
     * @constant
     * @memberOf const.MessageConst
     */
    ID036: 'ログイン画面にお戻りください。',

    /**
     * 仮登録情報が存在しません。再度仮登録から行ってください。
     * @name ID037
     * @constant
     * @memberOf const.MessageConst
     */
    ID037: '仮登録情報が存在しません。再度仮登録から行ってください。'
  },
  ACCOUNT_PROVISIONAL_REGIST: {
    /**
     * ユーザー仮登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ユーザー仮登録',

    /**
     * メールアドレスを入力してください。
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'メールアドレスを入力してください。',

    /**
     * 本登録用URLをメールにてお知らせします。
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '本登録用URLをメールにてお知らせします。',

    /**
     * メールアドレス
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: 'メールアドレス'
  },
  ACCOUNT_REGIST: {
    /**
     * ユーザー登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ユーザー登録',

    /**
     * 業者名
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '業者名',

    /**
     * 氏名
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '氏名',

    /**
     * ログインID
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: 'ログインID',

    /**
     * パスワード
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: 'パスワード',

    /**
     * メールアドレス
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: 'メールアドレス',

    /**
     * ※半角スペースは入力しないでください。
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '※半角スペースは入力しないでください。'
  },
  PASSWORD_REISSUE: {
    /**
     * パスワード再設定
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'パスワード再設定',

    /**
     * 登録されているログインIDとメールアドレスを入力してください。
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録されているログインIDとメールアドレスを入力してください。',

    /**
     * 新規パスワードをメールにてお知らせします。
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '新規パスワードをメールにてお知らせします。',

    /**
     * メールアドレス
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'メールアドレス',

    /**
     * ログインID
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: 'ログインID'
  },

  PORTAL_TOP: {
    /**
     * 本日の予約一覧
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '本日の予約一覧',

    /**
     * 予約
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '予約',

    /**
     * お知らせ
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'お知らせ',

    /**
     * 投稿
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '投稿',

    /**
     * 予約可能なセンターが存在しません。
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '予約可能なセンターが存在しません。',

    /**
     * お知らせはありません。
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: 'お知らせはありません。',

    /**
     *  本日の混雑状況
     * @name ID043
     * @constant
     * @memberOf const.MessageConst
     */
    ID043: ' 本日の混雑状況'
  },
  PORTAL_MY_PAGE: {
    /**
     * アカウント情報編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'アカウント情報編集',

    /**
     * 配送会社名
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '輸送業者名',

    /**
     * ユーザー名
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: 'ユーザー名',

    /**
     * メールアドレス
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: 'メールアドレス',

    /**
     * パスワードを変更する
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: 'パスワードを変更する',

    /**
     * 現在のパスワード
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '現在のパスワード',

    /**
     * 新しいパスワード
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '新しいパスワード',

    /**
     * （再確認）
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '（再確認）',

    /**
     * ログインID
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: 'ログインID',

    /**
     * 運送会社名
     * @name ID029
     * @constant
     * @memberOf const.MessageConst
     */
    ID029: '運送会社名',

    /**
     * キャンセル
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'キャンセル',

    /**
     * 変更
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '変更',

    /**
     * 電話番号
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '電話番号'
  },
  CAR_COMMON: {
    /**
     * 運送会社名
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '運送会社名',

    /**
     * 車番
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '車番',

    /**
     * 陸運支局
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '陸運支局',

    /**
     * 分類番号
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: '分類番号',

    /**
     * 用途コード
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '用途コード',

    /**
     * 一連番号
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: '一連番号',

    /**
     * キャンセル
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: 'キャンセル',

    /**
     * 戻る
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: '戻る'
  },
  CAR_LIST: {
    /**
     * 登録車両番号一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '登録車両番号一覧',

    /**
     * 検索
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '検索',

    /**
     * 検索結果を出力
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '検索結果を出力',

    /**
     * 新規車両番号登録
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '新規車両番号登録',

    /**
     * 詳細
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '詳細',

    /**
     * 編集
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '編集',

    /**
     * 選択した車両番号を削除
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '選択した車両番号を削除',

    /**
     * CSV読み込み登録
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: 'CSV読み込み登録',

    /**
     * 運送会社
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: '運送会社'
  },
  CAR_REGIST: {
    /**
     * 車両番号登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '車両番号登録',

    /**
     * 登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録',

    /**
     * 車両番号
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '車両番号'
  },
  CAR_CSV_REGIST: {
    /**
     * 車両番号CSV登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '車両番号CSV登録',

    /**
     * CSVを選択してください
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'CSVを選択してください',

    /**
     * ファイルを選択
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'ファイルを選択',

    /**
     * 選択されていません
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '選択されていません',

    /**
     * 登録する
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '登録する'
  },
  CAR_CONFIRMATION: {
    /**
     * 車両番号詳細
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '車両番号詳細',

    /**
     * 内容を変更する
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '内容を変更する'
  },
  CAR_EDIT: {
    /**
     * 車両番号編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '車両番号編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更'
  },
  DRIVER_COMMON: {
    /**
     * 運送会社名
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '運送会社名',

    /**
     * ドライバー名
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: 'ドライバー名',

    /**
     * 電話番号
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '電話番号',

    /**
     * メールアドレス
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: 'メールアドレス',

    /**
     * 戻る
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '戻る',

    /**
     * キャンセル
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: 'キャンセル',

    /**
     * ログインID
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: 'ログインID',

    /**
     * パスワード
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: 'パスワード',

    /**
     * 有効
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '有効',

    /**
     * 無効
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '無効',

    /**
     * このドライバーに予約登録させる場合、有効を選択してください
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'このドライバーに予約登録させる場合、有効を選択してください'
  },
  DRIVER_LIST: {
    /**
     * ドライバー一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ドライバー一覧',

    /**
     * 検索
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '検索',

    /**
     * 検索結果を出力
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '検索結果を出力',

    /**
     * 新規ドライバー登録
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '新規ドライバー登録',

    /**
     * 詳細
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '詳細',

    /**
     * 編集
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '編集',

    /**
     * 選択したドライバーを削除
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '選択したドライバーを削除',

    /**
     * CSV読み込み登録
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: 'CSV読み込み登録',

    /**
     * 運送会社
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: '運送会社'
  },
  DRIVER_REGIST: {
    /**
     * ドライバー登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ドライバー登録',

    /**
     * 登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録',

    /**
     * ※半角スペースは入力しないでください。
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '※半角スペースは入力しないでください。'
  },
  DRIVER_CSV_REGIST: {
    /**
     * ドライバーCSV登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ドライバーCSV登録',

    /**
     * CSVを選択してください
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'CSVを選択してください',

    /**
     * ファイルを選択
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'ファイルを選択',

    /**
     * 選択されていません
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '選択されていません',

    /**
     * 登録する
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '登録する'
  },
  DRIVER_CONFIRMATION: {
    /**
     * ドライバー詳細
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ドライバー詳細',

    /**
     * 内容を変更する
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '内容を変更する'
  },
  DRIVER_EDIT: {
    /**
     * ドライバー編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ドライバー編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更',

    /**
     * このドライバーは予約登録可能です
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'このドライバーは予約登録可能です',

    /**
     * このドライバーは予約登録できません
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: 'このドライバーは予約登録できません',

    /**
     * ●●●●●●●●●●
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '●●●●●●●●●●'
  }
};

export default MessageConst;



// WEBPACK FOOTER //
// ./src/js/const/MessageConst.jsx